module.exports = __webpack_public_path__ + "static/media/join-comm-icon-collapsed.938a4b31.svg";